/**
 * Case numbers are a backend integer sequence (Case.caseNumber, review ruling
 * A on Asana 1219952262403623); the API sends the raw integer and every
 * surface formats it here, as "C-1182". Returns null when the backend did not
 * send one so callers can fall back to copy without a number.
 */
export const formatCaseNumber = (caseNumber: number | null | undefined): string | null =>
  typeof caseNumber === 'number' && Number.isFinite(caseNumber) ? `C-${caseNumber}` : null;
